<template>
  <form class="form" @submit.prevent="submitForm">
    <h3 class="form__heading">Прочитайте документы ниже и подпишите их</h3>
    <br />
    <p class="form__paragraph">
      Для подписания необходимо запустить программу NCALayer. Инструкция по
      запуску находится
      <a class="form__link" href="http://pki.gov.kz/index.php/ru/ncalayer"
        >по ссылке</a
      >
    </p>
    <ul id="files">
      <li v-for="doc in this.documents_list">
        <a
          :href="`${config.fileAbsUrl}${doc.url}`"
          class="form__link"
          target="_blank"
          >{{ doc.name }}</a
        >
      </li>
    </ul>

    <textarea class="hidden" v-model="signBody"></textarea>
    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <button @click="goEdit()" type="button" class="button form__button">
          Редактровать анкету
        </button>
        <v-dialog name="wanna_edit"
          >Вы будете направлены в начало регистрации для редактировния
          данных.</v-dialog
        >
      </div>
      <div class="col-xs-12 col-sm-6">
        <button
          :disabled="signed"
          v-bind:class="{ disabled: signed }"
          v-on:click="xmlSign()"
          type="button"
          class="button filled form__button"
        >
          <span v-if="!isEcpLoading">Подписать</span>
          <span v-if="isEcpLoading">
            <spinner :animation-duration="1000" :size="17" :color="'#ffffff'" />
          </span>
        </button>
      </div>
    </div>
  </form>
</template>
<script>
import { FhsAxios } from "../../../services/axios";
import RegFormMixin from "../form_mixin";
import user from "@/store/modules/user.js";
import Vue from "vue";
export default {
  data() {
    return {
      iin: user.state.iin,
      bin: user.state.bin,
      errors: "",
      signBody: "",
      signed: false,
      sent: false,
      documents_list: null,
      isEcpLoading: false
    };
  },
  mixins: [RegFormMixin],
  watch: {},
  mounted() {
    FhsAxios.get("user/get-user-documents-list", {
      data: null,
      params: {
        typeGroup: this.isUserLegal ? "u-generated" : null
      }
    }).then(response => {
      // console.log(response);
      if (response.data.status == 1) {
        this.documents_list = response.data.result;
      } else {
        this.documents_list = {};
      }
    });
  },
  components: {},
  methods: {
    goEdit() {
      try {
        this.$modal.show("dialog", {
          title: "Внимание",
          text:
            "Вы будете направлены в начало регистрации для редактировния данных.",
          buttons: [
            {
              title: "Закрыть"
            },
            {
              title: "Да",
              handler: () => {
                this.changeStatus();
              }
            }
          ]
        });
      } catch (e) {
        console.log(e);
      }
    },
    checkForm() {
      return true;
    },
    goEditFormData() {},
    xmlSign: function() {
      this.isEcpLoading = true;
      if (!Vue.prototype.$isLayerConnected()) {
        Vue.prototype.$reconnectLayer();

        setTimeout(() => {
          if (!Vue.prototype.$isLayerConnected()) {
            this.isEcpLoading = false;
            return this.$toasted.error(
              "Программа NCALayer не запущена. Запустите ее и повторите попытку."
            );
          }

          this.isEcpLoading = false;
          if (this.checkForm()) {
            let signXml = this.getXml();
            return Vue.prototype.$signXmlCall(signXml, this, "signBody");
          }
        }, 2000);
      } else {
        if (this.checkForm()) {
          let signXml = this.getXml();
          return Vue.prototype.$signXmlCall(signXml, this, "signBody");
        }
        this.isEcpLoading = false;
      }
      return false;
      //
    },
    getXml() {
      let xml =
        '<?xml version="1.0" encoding="UTF-8"?>' +
        "<ClientApproval>" +
        "<time>" +
        new Date().getTime() +
        "</time>" +
        "<Iin>" +
        this.iin +
        "</Iin>" +
        "<Bin>" +
        this.bin +
        "</Bin>";

      for (let i = 0; i < this.documents_list.length; i++) {
        xml += "<FileHash>" + this.documents_list[i].file_hash + "</FileHash>";
      }

      xml += "</ClientApproval>";

      return xml;
    },
    changeStatus() {
      const system_status = 0;
      FhsAxios.post(`user/remove-user-documents`, {
        params: {
          typeGroup: this.isUserLegal ? "u-generated" : null
        }
      }).then(() => {
        FhsAxios.post(`registration-order/change-status`, {
          status_id: 1,
          system_status: system_status
        }).then(response => {
          console.log(response);
          if (response.data.status) {
            const delay = 3000;
            this.$toasted.show("Подождите", { duration: delay });
            setTimeout(() => {
              this.$store.commit("setUserSystemStatus", 0);
              if (this.isUserLegal) {
                this.$router.push({ name: "legal-entity-register" });
              } else {
                this.$router.push({ name: "general-info" });
              }
            }, delay);
          } else {
            this.$toasted.show("Произошла ошибка, при смене статуса");
          }
        });
      });
    },
    submitForm() {
      // console.log("submit form");
      let data = this._data;
      delete data.errors;
      delete data.signed;
      this.$emit("loading-status", true);
      FhsAxios.post("registration-order/client-approval", data)
        .then(response => {
          // console.log(response.data);
          if (response.data.status) {
            // console.log("redirect to next page");
            this.$store.dispatch("getUserSystemStatus").then(res => {
              if (res.data.status) {
                this.$store.commit(
                  "setUserSystemStatus",
                  res.data.result.system_status
                );
                this.$emit("loading-status", false);
                this.$router.push({ name: "sign-inprogress" });
              } else {
                throw new Error(res);
              }
            });
            return;
          } else {
            this.$toasted.error("Ошибка при подписании");
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    checkSign() {
      FhsAxios.post("utilities/eds/validate", {
        iin: user.state.iin || null,
        bin: user.state.bin || null,
        sign: btoa(this.signBody)
      }).then(response => {
        if (response.data.status == 1) {
          // console.log("sign is valid!");
          Vue.signModel.signed = true;
          this.submitForm();
        } else {
          let err = response.data.result.error;

          if (typeof err === "undefined") {
            err = response.data.result.errors;
          }

          if (typeof err === "string") {
            this.$toasted.error(err);
          } else {
            response.data.result.error.forEach(each => {
              this.$toasted.error(each);
            });
          }
        }
      });
    }
  },
  getters: {}
};
</script>
<style scoped>
.form__button {
  margin-top: 20px;
  padding: 15px 0;
  font-size: 15px;
}

form {
  color: white;
}

.form__link {
  color: #2e79ef;
}

.form_button.disabled {
  background-color: transparent !important;
}
</style>
